import React from "react";

const IdentityIntroVideo = ({ subsection, saveProgress }) => {
  const about = (
    <div className="space-y-5 pt-2 pb-6 text-body leading-7 text-[#484848]">
      <p>
      This lesson goes after the quieter promotion myths people carry for years. It challenges ideas like “I’ll get my turn when someone leaves,” “bad times mean no promotions,” and “my boss decides everything.” It reframes politics as stakeholder awareness, not manipulation, and shows why one big win or a risky project rarely beats a steady reputation. The core idea: promotions are shaped months ahead by consistent, visible choices.
      </p>

    </div>
  );

  // SWAPPED: Now has the #8-#14 trickier myths transcript
  const transcriptHtml = `
    <p>In the last video, we uncovered the big, obvious myths, the ones everyone talks about.</p>

    <p>Now let's look at the more trickier ones..</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#8 Promotion comes after someone leaves.</h3>
    <p>Opportunities aren't just reactive. You can create space by expanding your scope and preparing in advance.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#9 Fixing my weaknesses is utmost important</h3>
    <p>Focusing only on weaknesses can distract from your real leverage. People who get promoted know how to maximize their strengths and double down on what sets them apart.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#10 Companies don't promote in bad times</h3>
    <p>Even in challenging periods, companies understand the value of good talent, they're always in short supply. If you consistently demonstrate impact and are seen as valuable, your chances of promotion don't just remain, they often grow exponentially.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#11 My boss decides alone</h3>
    <p>Promotions involve multiple stakeholders. You own your dossier, and your boss can only amplify your case when you equip them properly.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#12 I don't do politics</h3>
    <p>Office politics isn't about manipulation, pretence, or pleasing people. Real politics is awareness, understanding what your stakeholders value and aligning your authentic self with it. You don't have to play games; just stay informed, intentional, and visible. You can be authentic and politically aware at the same time.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#13 One big win is enough</h3>
    <p>One great project might get you noticed, but it won't build lasting trust.</p>
    <p>Managers bet on consistency. The reputation you build through consistent results, professional conduct, and visible impact, your brand, matters far more than one isolated achievement. That brand is what sticks in the minds of decision-makers when opportunities arise. One win may open a door, but your brand ensures you stay in the room.</p>

    <h3 style="margin-top: 24px; margin-bottom: 12px; font-weight: 700; font-size: 1.125rem;">#14 Complex or risky projects are key</h3>
    <p>Choose projects by Impact × Certainty × Visibility. It's tempting to chase complex or high-risk projects, thinking they'll make you stand out. But most companies are, at their core, risk-management machines, they value reliable, repeatable performance over occasional brilliance.</p>

    <p>Taking on a tough project or a challenging client can pay off, but only if there's a clear path to recognition or reward upon successful completion. Being a martyr rarely moves the needle. Just like one big win isn't enough, your impact grows through steady, measurable achievements that build other's confidence in your performance over time.</p>

    <p><strong>Promotions aren't karma, they're calculus.</strong> Every decision you make contributes to your growth. It's not a single event, it's shaped months in advance through consistent choices, ongoing calibration, and visible proof of your impact.</p>

    <p><strong>Which myth are you carrying?</strong></p>
  `;

  const transcript = (
    <div
      className="pt-2 pb-6 text-body leading-7 text-[#484848] max-w-2xl"
      dangerouslySetInnerHTML={{ __html: transcriptHtml }}
    />
  );

  // const relatedLinks = (
  //   <div className="pt-2 pb-6">
  //     <ul className="list-disc list-inside text-body space-y-2">
  //       <li>
  //         <button type="button" className="text-link">
  //           Download Slides
  //         </button>
  //       </li>
  //       <li>
  //         <button type="button" className="text-link">
  //           Reference Reading: Career Transitions Report 2025
  //         </button>
  //       </li>
  //     </ul>
  //   </div>
  // );

  const notes = (
    <div className="pt-2 pb-6">
      <textarea
        rows={4}
        placeholder="Write your notes here..."
        className="w-full border border-gray-200 rounded-xl p-3 text-body focus:ring-2 focus:ring-brand/40 focus:outline-none"
        onBlur={(e) => saveProgress("in_progress", { notes: e.target.value })}
      />
    </div>
  );

  return { about, transcript, notes };
};

export default IdentityIntroVideo;

